import { render, staticRenderFns } from "./FormulateSwitch.vue?vue&type=template&id=1fc0b557&"
import script from "./FormulateSwitch.vue?vue&type=script&lang=js&"
export * from "./FormulateSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fc0b557')) {
      api.createRecord('1fc0b557', component.options)
    } else {
      api.reload('1fc0b557', component.options)
    }
    module.hot.accept("./FormulateSwitch.vue?vue&type=template&id=1fc0b557&", function () {
      api.rerender('1fc0b557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/switch/FormulateSwitch.vue"
export default component.exports